import CustomTextBox from "app/components/atoms/customTextBox";
import CustomSelect from "app/components/atoms/customSelect";

export const employerSearchOptInUiSchema = {
  "ui:title": "",
  ctpt_connectsearch: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  ctpt_discipline: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_qualifications: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_professionalregistration: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_employmentstatus: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  ctpt_willingtorelocate: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  ctpt_employmenttype: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  _ctpt_branchid_value: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
};

